export * from './login';
export * from './session';
export * from './user';
export * from './xsrf';


import {loginReducer as login} from './login';
import {sessionReducer as session} from './session';
import {userReducer as user} from './user';
import {websiteReducer as Website} from './website';
import {xsrfReducer as xsrf} from './xsrf';
import {adReducer as Ads} from './advertise';
import {billingReducer as Billing} from './billing';


export const reducers = {login,session,user,Website,xsrf,Ads,Billing};
